import { memo, ReactNode } from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { styled } from '@mui/material'

import CardBase from 'features/common/ui/Cards/CardBase/CardBase'

import MapCardHeader from './MapCardHeader'
import { DemoMap, Map } from 'features/maps/types'
import MapThumbnail from './MapThumbnail'
import MapCardFooter from './MapCardFooter'
import { targetOrParentHasClass } from 'features/common/utils/dom'
import Loader from 'features/common/ui/utils/Loader'

interface MapCardProps {
  map: Map | DemoMap
  loading?: boolean
  loadingMessage?: ReactNode
  demo?: boolean
  onClick?: () => void
}

const Card = styled(CardBase)(() => ({
  position: 'relative'
}))

const LoaderStyled = styled(Loader)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.white[90],
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10
}))

function MapCard({ map, onClick, loading, loadingMessage, demo }: MapCardProps) {
  const intl = useIntl()
  const { title = '', updatedAt, thumbnailUrl, ownerPicture, ownerEmail, ownerIsCartoUser } = map
  const mapTitle = title || intl.formatMessage({ id: 'maps.default.title' })

  const handleClick = (ev) => {
    if (targetOrParentHasClass(ev.target, 'MuiButtonBase-root')) return

    onClick?.()
  }

  return (
    <Card onClick={handleClick} aria-label={mapTitle}>
      {loading && <LoaderStyled label={loadingMessage} />}
      <Box aria-label="map-card">
        <MapThumbnail title={mapTitle} url={thumbnailUrl} />
        <MapCardHeader map={map} onCreateFromTemplate={onClick} />
        <MapCardFooter
          ownerPicture={ownerPicture}
          ownerEmail={ownerEmail}
          ownerIsCartoUser={ownerIsCartoUser}
          updatedAt={updatedAt}
          tags={map.tags}
          isDemo={demo}
        />
      </Box>
    </Card>
  )
}

export default memo(MapCard)
